import React from "react";
import { Link, useParams } from "react-router-dom";
import { Clock, CloudSun, Compass, ShieldCheck, Star } from "lucide-react";
import { Button } from "@/components/ui/button";
import NewsletterSignup from "@/components/public/NewsletterSignup";
import { useLanguage } from "@/lib/LanguageContext";
import { getSubscriptionPitchCopy } from "@/lib/subscriptionPitchTranslations";

const outcomeIcons = [Compass, CloudSun, Clock];

export default function WhySubscribeSection({ showNewsletter = false }) {
  const { lang: routeLang } = useParams();
  const { language } = useLanguage();
  const lang = routeLang || language || "en";
  const prefix = lang === "en" ? "/en" : `/${lang}`;
  const copy = getSubscriptionPitchCopy(lang).why;
  const outcomes = copy.outcomes.map(([title, text], index) => ({ icon: outcomeIcons[index] || Compass, title, text }));

  return (
    <section className="maritime-container maritime-section">
      <div className="rounded-[2.5rem] border border-primary/20 bg-card p-6 shadow-2xl shadow-ocean/10 md:p-10">
        <div className="grid gap-8 lg:grid-cols-[0.9fr_1.1fr] lg:items-start">
          <div>
            <p className="text-sm font-black uppercase tracking-[0.22em] text-primary">{copy.eyebrow}</p>
            <h2 className="mt-3 font-heading text-4xl font-black md:text-5xl">{copy.title}</h2>
            <p className="mt-4 text-lg leading-8 text-muted-foreground">{copy.text}</p>
            <div className="mt-6 flex flex-col gap-3 sm:flex-row">
              <Button asChild><Link to={`${prefix}/premium`}>{copy.upgrade}</Link></Button>
              <Button asChild variant="outline"><Link to={`${prefix}/daily-briefing`}>{copy.briefing}</Link></Button>
            </div>
          </div>
          <div className="grid gap-4 md:grid-cols-3">
            {outcomes.map(({ icon: Icon, title, text }) => (
              <div key={title} className="rounded-[1.5rem] border border-border bg-background/70 p-5">
                <Icon className="h-7 w-7 text-primary" />
                <h3 className="mt-4 text-lg font-black">{title}</h3>
                <p className="mt-2 text-sm leading-6 text-muted-foreground">{text}</p>
              </div>
            ))}
          </div>
        </div>
        <div className="mt-8 grid gap-4 md:grid-cols-3">
          {copy.trust.map((item, index) => (
            <div key={item} className="flex items-start gap-3 rounded-2xl bg-primary/10 p-4 text-sm font-bold text-primary">
              {index === 0 ? <Star className="h-5 w-5" /> : <ShieldCheck className="h-5 w-5" />}
              <span>{item}</span>
            </div>
          ))}
        </div>
        {showNewsletter && <div className="mt-8"><NewsletterSignup compact /></div>}
      </div>
    </section>
  );
}